const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-10/PNG%20n.2/3d%2010-2/publish%2010-2/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 10 Level 2 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
